import { Injectable } from '@angular/core';
import { ToastController } from 'ionic-angular';
import { Events } from 'ionic-angular';
import { ToastHelperProvider } from '../../providers/toast-helper/toast-helper';
import { Html5Qrcode } from 'html5-qrcode';

declare var GibberishAES;
/*
  Generated class for the QrHelperProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class QrHelperProvider {
  private html5Qrcode: Html5Qrcode = null;
  public isScanning: Boolean = false;
  public scanResult;

  constructor(public toastCtrl: ToastController,
              public events: Events,
              public toastHelper: ToastHelperProvider) {
  }

  startQr(scanEventName, elementId: string = 'qr-reader') {
    this.isScanning = true;
    // Small delay to allow Angular change detection to render the element
    setTimeout(() => {
      this.html5Qrcode = new Html5Qrcode(elementId);
      this.html5Qrcode.start(
        { facingMode: 'environment' },
        { fps: 10, qrbox: { width: 250, height: 250 } },
        (decodedText: string) => {
          this.events.publish(scanEventName, this.decodeText(decodedText));
          this.destroyQr();
        },
        () => {} // ignore per-frame errors
      ).catch((e: any) => {
        console.log('QR Error:', e);
        this.toastHelper.showToast('ERROR: Camera kon niet gestart worden.', 'error');
        this.isScanning = false;
      });
    }, 100);
  }

  decodeText(text) {
    let passKey = 'The Craft NV Is gelegen te Melle op de Brusselsestraat 197. Ze hebben dit project voor VGGO gemaakt.';
    return GibberishAES.dec(text, passKey);
  }

  destroyQr() {
    this.isScanning = false;
    if (this.html5Qrcode) {
      const scanner = this.html5Qrcode;
      this.html5Qrcode = null;
      scanner.stop()
        .then(() => scanner.clear())
        .catch(() => {
          try { scanner.clear(); } catch (e) {}
        });
    }
  }

  // No-ops in browser — were used to make webview transparent over native camera
  showCamera() {}
  hideCamera() {}
}



// WEBPACK FOOTER //
// ./src/providers/qr-helper/qr-helper.ts